import cn from 'classnames';
import Image from 'next/image';

export const Banner = () => {
  return (
    <div
      className={cn(
        'hidden lg:flex',
        'w-full bg-SnapBlue min-h-[120px] h-auto',
        'px-[20px] lg:px-4',
        'flex flex-col lg:flex-row items-center lg:items-center justify-center py-4 lg:py-0'
      )}
    >
      <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between w-full xl:max-w-7xl xl:mx-auto space-y-4 lg:space-y-0">
        {/* Left: Image and text */}
        <div className="flex flex-col lg:flex-row items-center lg:items-stretch">
          {/* Only show image on large screens */}
          <div className="hidden lg:flex items-center lg:items-stretch h-[64px] md:h-[80px] lg:h-full">
            <Image
              src="/assets/million_downloads.png"
              alt="1M Mobile App Downloads"
              width={192}
              height={154}
              className="object-contain h-[64px] w-auto md:h-[80px] lg:h-full"
              priority
            />
          </div>
          <div className="lg:ml-6 text-center lg:text-left flex flex-col justify-center">
            <span
              className="font-bold text-[1rem] leading-6 tracking-[0.02em]"
              style={{ color: '#FFCA4D', fontFamily: 'Aeonik, sans-serif' }}
            >
              Snap is celebrating 1M app downloads!
            </span>
            <span
              className="text-white text-[1rem] leading-6 tracking-[0.02em] font-normal"
              style={{ fontFamily: 'Aeonik, sans-serif' }}
            >
              Download our award-winning app now to manage your lease on the go.
            </span>
          </div>
        </div>
        {/* Right: QR Code - aligned with logout button */}
        <Image
          src="/assets/million_qr_code.png"
          alt="Mobile App Store QR Code"
          width={64}
          height={64}
          className="object-contain bg-white rounded h-[64px] w-[64px] md:h-[80px] md:w-[80px] lg:h-[114px] lg:w-[114px]"
          priority
        />
      </div>
    </div>
  );
};
